// this is an autogenerated file from App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Medical/Content/SyncAction/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Patients_Content_Content_Sections_ActiveTab_Medical_Content_SyncAction($patient_id: uuid!, $organization_id: uuid!) {
  last_questions: medical_histories_questions(
    where: {
      organization_id: { _eq: $organization_id }
      status: { _eq: active }
    }
    order_by: [{ name: asc }, { type: asc }, { created_at: desc }]
  ) {
    id
    organization_id
    name
    type
    created_at
    answers(where: { patient_id: { _eq: $patient_id } }) {
      id
    }
  }
  last_answers: medical_histories_answers(
    where: { patient_id: { _eq: $patient_id } }
    order_by: [
      { question: { organization_id: asc } }
      { question: { name: asc } }
      { question: { type: asc } }
      { created_at: desc }
    ]
  ) {
    id
    question_id
    value
    alert
    created_by
    created_at
    question {
      organization_id
      name
      type
    }
  }
}

`